import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export const Viewbutton = ({ size, onSelectView }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState('Masonry');

    const toggle = () => setDropdownOpen(prevState => !prevState);

    const handleItemClick = (item) => {
        setSelectedItem(item);
        onSelectView(item); 
    };

    return (
        <div className="d-flex">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret size={size} style={{backgroundColor:'white',color:'black',padding:'9px',fontSize:'14px'}}>
                    {selectedItem}
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => handleItemClick('Masonry')}>Masonry</DropdownItem>
                    <DropdownItem onClick={() => handleItemClick('Grid')}>Grid</DropdownItem>
                    <DropdownItem onClick={() => handleItemClick('List')}>List</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
    );
};
